import { StandardSvgProps } from 'src/components/svg/StandardSvgProps';
import { SDefaultSvg, SFilledPath } from 'src/components/svg/SvgStyles';

//#region [Props]
type CameraSvgProps = {
} & StandardSvgProps;
//#endregion

//#region [Component]
export default function CameraCircleSvg({ className }: CameraSvgProps) {
	return (<SDefaultSvg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
		<path
			d="M 20 0 C 9 0 0 9 0 20 C 0 31 9 40 20 40 C 31 40 40 31 40 20 C 40 9 31 0 20 0 z M 16.275391 11.160156 A 2.072 2.072 0 0 1 16.306641 11.160156 L 23.642578 11.160156 A 2.072 2.072 0 0 1 25.300781 11.9375 L 26.207031 13.429688 L 32.072266 13.429688 A 1.182 1.182 0 0 1 33.255859 14.609375 L 33.255859 27.660156 A 1.183 1.183 0 0 1 32.076172 28.839844 L 7.9238281 28.839844 A 1.183 1.183 0 0 1 6.7441406 27.660156 L 6.7441406 14.609375 A 1.182 1.182 0 0 1 7.9277344 13.429688 L 8.828125 13.429688 A 0.8 0.8 0 0 1 9.5371094 13.003906 L 11.810547 13.003906 A 0.8 0.8 0 0 1 12.519531 13.429688 L 13.744141 13.429688 L 14.650391 11.9375 A 2.072 2.072 0 0 1 16.275391 11.160156 z M 20.142578 14.867188 A 5.988 5.988 0 1 0 26.130859 20.855469 A 5.988 5.988 0 0 0 20.142578 14.867188 z M 19.953125 16.296875 A 4.563 4.563 0 0 1 24.707031 20.855469 A 4.563 4.563 0 0 1 20.142578 25.417969 A 4.563 4.563 0 0 1 19.953125 16.296875 z "
		/>
	</SDefaultSvg>)
}
//#endregion